export default "__VITE_ASSET__451e6c4f__"